import { render, staticRenderFns } from "./AssignmentsManager.vue?vue&type=template&id=47844c30&"
import script from "./AssignmentsManager.vue?vue&type=script&lang=js&"
export * from "./AssignmentsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports